import request from "@/config/utils/request";

// 编辑
export function edit(data) {
  return request({
    url: "/apis/demo/pcconcmat/editPcConcMat",
    method: "POST",
    data
  });
}
// 添加
export function add(data) {
  return request({
    url: "/apis/demo/pcconcmat/addPcConcMat",
    method: "POST",
    data
  });
}
// 删除
export function del(data) {
  return request({
    url: "/apis/demo/pcconcmat/deletePcConcMat", // 后端接口
    method: "post",
    data
  });
}
// 详情
export function getListDetail(data) {
  return request({
    url: "/apis/demo/pcconcmat/getPcConcMatById", // 后端接口
    method: "POST",
    data
  });
}
// 批量查询
export function list(data) {
  return request({
    url: "/apis/demo/pcconcmat/listPcConcMat",
    method: "POST",
    data
  });
}
